import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Card,CardBody,Row,Col, Button} from 'reactstrap'
import Input from '../common/inputComponent'
import DatePicker from "react-datepicker";
import {createNewRoll} from '../../actions/rollActions'
 
import "react-datepicker/dist/react-datepicker.css";


class newRollCall extends Component {
  constructor(){
    super()
    this.state={
      Name:'',
      Date:''
    }
    this.handleChange = this.handleChange.bind(this)
    this.onChange = this.onChange.bind(this)
    this._onSubmit = this._onSubmit.bind(this)
  }
  handleChange = date => {
    this.setState({
      Date: date
    });
  };
  onChange(e){
    this.setState({[e.target.name]:e.target.value})
  }
  _onSubmit(e){
    e.preventDefault()
    this.props.createNewRoll({Name:this.state.Name,Date:this.state.Date})
  }
  render() {
    return (
      <div className="main-content">
        <Card>
          <CardBody>
            <h4>Thêm mới sự kiện điểm danh.</h4>
            <form onSubmit={this._onSubmit}>
            <Row className="m-t-25">
              <Col md={12} className="m-t-25">
                <Input name="Name" placeholder="Nhập tên cho buổi học:" value={this.state.Name} onChange={this.onChange}/>
              </Col>
              <Col md={12} className="m-t-25">
                <label>Ngày diễn ra sự kiện: </label>{' '}
                <DatePicker className="form-control" selected={this.state.Date} onChange={this.handleChange}/>
              </Col>
              <Col md={12} className="m-t-25">
                <Button>Save</Button>
                
              </Col>
            </Row>
            </form>
          </CardBody>
        </Card>
      </div>
    )
  }
}

newRollCall.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps,{createNewRoll})(newRollCall); 


// WEBPACK FOOTER //
// ./src/components/pages/newRollCall.js